import {BaseModel} from "../../base/models/base-model.model";
import {ProductState} from "../../shared/DTO/productState";
import {ProcessToModel} from "./process-to.model";
import {StateChangeToModel} from "./state-change-to.model";

export class TransictionStateModel extends BaseModel {
  private _processes?: Array<ProcessToModel>;
  private _state?: ProductState;
  private _stateChanges?: Array<StateChangeToModel>;

  constructor(processes?: Array<ProcessToModel>, state?: ProductState, stateChanges?: Array<StateChangeToModel>) {
    super();
    this._processes = processes;
    this._state = state;
    this._stateChanges = stateChanges;
  }

  get processes(): Array<ProcessToModel> {
    return this._processes;
  }

  set processes(value: Array<ProcessToModel>) {
    this._processes = value;
  }

  get state(): ProductState {
    return this._state;
  }

  set state(value: ProductState) {
    this._state = value;
  }

  get stateChanges(): Array<StateChangeToModel> {
    return this._stateChanges;
  }

  set stateChanges(value: Array<StateChangeToModel>) {
    this._stateChanges = value;
  }
}
